namespace TabAurous.Production {
    export interface MergingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        DepartmentId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        Details: MergingItemsEditor;
        UserId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class MergingForm extends Serenity.PrefixedContext {
        static formKey = 'Production.Merging';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MergingForm.init)  {
                MergingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = MergingItemsEditor;

                Q.initFormType(MergingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherTypeId', w2,
                    'VoucherNo', w0,
                    'DepartmentId', w3,
                    'BagNo', w0,
                    'Pieces', w2,
                    'Weight', w4,
                    'Details', w5,
                    'UserId', w2,
                    'EmployeeId', w2,
                    'CompanyId', w2,
                    'FinancialYearId', w2
                ]);
            }
        }
    }
}
